var map = {
	"./logo-design.de.json": 93546,
	"./logo-design.en.json": 85653,
	"./logo-design.es.json": 43485,
	"./logo-design.fr.json": 48501,
	"./logo-design.it.json": 33254,
	"./logo-design.ja.json": 55128,
	"./logo-design.nl.json": 64402,
	"./logo-design.pt.json": 22551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88952;